import { ThemeOptions, createTheme } from "@mui/material/styles";

export const baseBlack = "rgb(0, 20, 0)";
export const baseWhite = "rgb(242, 247, 245)";
export const outlawGreen = "rgb(0, 224, 137)";
export const outlawDarkGreen = "rgb(0, 95, 60)";

export const terminalPurple = "rgb(130, 100, 255)";
export const programPink = "rgb(255, 94, 245)";
export const cyberYellow = "rgb(255, 212, 0)";
export const operatorOrange = "rgb(255, 77, 00)";
export const operatorOrangeLight = "rgb(255, 187, 153)";
export const operatorOrangeDark = "rgb(102, 34, 0)";

export const baseBlack90 = "rgba(0, 20, 0, 0.9)";
export const baseBlack60 = "rgba(0, 20, 0, 0.6)";
export const baseBlack40 = "rgba(0, 20, 0, 0.4)";

export const baseWhiteSheen = "rgba(250, 255, 253)";

export const themeOptions: ThemeOptions = {
    palette: {
        primary: {
            main: outlawDarkGreen,
            contrastText: baseWhite,
        },
        secondary: {
            main: outlawGreen,
            contrastText: baseBlack,
        },
        background: {
            default: baseWhite,
            paper: baseWhite,
        },
        text: {
            primary: baseBlack90,
            secondary: baseBlack60,
            disabled: baseBlack40,
        },
        error: {
            main: operatorOrange,
            contrastText: baseWhite,
        },
        info: {
            main: terminalPurple,
            contrastText: baseWhite,
        },
        success: {
            main: outlawGreen,
            contrastText: baseBlack,
        },
        warning: {
            main: operatorOrangeLight,
            contrastText: operatorOrangeDark
        },
        divider: baseBlack40,
    },
    spacing: 12,
    shape: {
        borderRadius: 3,
    },
    typography: {
        fontFamily: '"Roobert", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: 48,
            fontWeight: 500,
        },
        h2: {
            fontSize: 32,
            fontWeight: 500,
        },
        h3: {
            fontSize: 24,
            fontWeight: 500,
        },
        h4: {
            fontSize: 20,
            fontWeight: 500,
        },
        h5: {
            fontSize: 18,
            fontWeight: 600,
        },
        h6: {
            fontSize: 16,
            fontWeight: 600,
        },
        subtitle1: {
            fontSize: 18,
            fontWeight: 500,
        },
        button: {
            fontSize: 18,
            fontWeight: 600,
            lineHeight: 2
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: baseBlack,
                    color: baseWhite,
                },
                a: {
                    color: outlawDarkGreen,
                    textDecoration: 'none',
                    fontWeight: 600,
                    ":hover": {
                        color: baseBlack,
                    },
                    ":focused": {
                        color: baseBlack,
                    },
                    ":active": {
                        color: outlawGreen,
                    },
                    "&.MuiButton-contained": {
                        ":hover": {
                            color: baseWhite,
                        },
                    }
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                gutterBottom: {
                    marginBottom: 24,
                },
                paragraph: {
                    marginBottom: 24,
                },
                root: {
                    '& .Mui-error': {
                        color: 'blue'
                    }
                }

            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '6px',
                },
                contained: {
                    backgroundColor: baseBlack,
                    color: baseWhite,
                },
                outlined: {
                    color: baseBlack,
                    borderColor: baseBlack,
                    outlineColor: baseBlack,
                    outlineStyle: "solid",
                    outlineWidth: '1px',
                },

            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    "&.Mui-error": {
                        color: operatorOrange
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: outlawDarkGreen,
                    fontWeight: 600,
                }
            }
        }

    },
};

export const theme = createTheme(themeOptions);
